import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import LocationService from '../services/LocationService';
import { itemPerPage } from '../baseUrls/consts';

const PointLocation = () => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("LOCATION_EN_COURS");
    const [loading, setLoading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        LocationService.getPointLocation((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {status: globalFilter}
        );
    }
   
    const choiceLocation = [
        { label: "LOCATION EN COURS", value: 'LOCATION_EN_COURS'},
        { label: "LOCATION TERMINÉE", value: 'LOCATION_TERMINEE'}
    ]


    return (
        <>
            <h5>Point des véhicules loués</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <span className="block mt-6 md:mt-0 p-input-icon-left mr-2">
                            <Dropdown value={globalFilter} options={choiceLocation} optionLabel="label"
                                onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Sélectionner" />
                        </span>
                        <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                            onClick={()=>{setLoading(true); loadItems()}} />
                    </React.Fragment>
                }  />
                
                
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} */
                loading={loading} /*  globalFilter={globalFilter}  */
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="vehicule.immatriculation" header="Véhicule" sortable />
                <Column field="dateDebut" header="Date début location" sortable 
                    body={(item)=> new Date(item.dateDebut).toLocaleDateString()}/>
                <Column field="dateFin" header="Date fin location" sortable style={{fontWeight: 'bold'}} 
                    body={(item)=> new Date(item.dateFin).toLocaleDateString()}/>
                <Column field="tiers.nom" header="Nom tiers" sortable />
                <Column field="montant" header="Montant" sortable body={item => item.montant?.toLocaleString()} />
            </DataTable>
        </>
    );
}


export default PointLocation;